module.exports = __webpack_public_path__ + "img/tab_logo.1e2cfdb2.png";